/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskAutomationEditRuleType from '@jira/spa-apps__project-settings-service-desk-automation-edit-rule/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskAutomationEditRule: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ProjectSettingsServiceDeskAutomationEditRuleType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-automation-edit-rule", jiraSpaEntry: "async-project-settings-service-desk-automation-edit-rule" */ '@jira/spa-apps__project-settings-service-desk-automation-edit-rule/src/index.tsx'
		),
);

const AsyncProjectSettingsServiceDeskAutomationEditRule = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskAutomationEditRule}
		pageId="project-settings-automation-edit-rule"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskAutomationEditRule;
